require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-mattersburg-rohrbach-bei-mattersburg.json") })
        }
      }, "path---betreuungseinrichtungen-mattersburg-rohrbach-bei-mattersburg");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-mattersburg-rohrbach-bei-mattersburg!./.cache/json/betreuungseinrichtungen-mattersburg-rohrbach-bei-mattersburg.json
// module id = 936
// module chunks = 231608221292675